import { Capacitor } from "@capacitor/core";

/** True when running inside the Capacitor iOS/Android shell (false on the website). */
export const isNativeApp = (): boolean => Capacitor.isNativePlatform();

export const nativePlatform = (): string => Capacitor.getPlatform(); // "ios" | "android" | "web"
